import { render } from "./NavbarPublic.vue?vue&type=template&id=25c638c8"
import script from "./NavbarPublic.vue?vue&type=script&lang=js"
export * from "./NavbarPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__